import { useCallback } from 'react';

import { useCreatePalletMutation } from '../api/palletsApi';
import type { CreatePalletRequest, CreatePalletParams, CreatePalletResponse } from '../api/palletsApi';

export interface UseCreatePalletOptions {
  onSuccess?: (data: CreatePalletResponse) => void;
  onError?: (error: unknown) => void;
}

export const useCreatePallet = (options?: UseCreatePalletOptions) => {
  const [createPallet, { isLoading, isSuccess, isError, error, data }] = useCreatePalletMutation();

  const handleCreate = useCallback(
    async (params: CreatePalletParams, request: CreatePalletRequest) => {
      try {
        const response = await createPallet({
          ...params,
          ...request
        }).unwrap();

        options?.onSuccess?.(response);
        return response;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [createPallet, options]
  );

  return {
    createPallet: handleCreate,
    isLoading,
    isSuccess,
    isError,
    error,
    data
  };
};
